<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold">{{ label }}</label>

    <div class="flex gap-2">
      <Multiselect
        v-model="fromValue"
        :options="yearOptions"
        :trackBy="'value'"
        :label="'label'"
        :valueProp="'value'"
        :placeholder="$t('filter.from')"
        :canClear="true"
        @change="debouncedEmit"
      />

      <Multiselect
        v-model="toValue"
        :options="yearOptions"
        :trackBy="'value'"
        :label="'label'"
        :valueProp="'value'"
        :placeholder="$t('filter.to')"
        :canClear="true"
        @change="debouncedEmit"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Multiselect from '@vueform/multiselect';
import api from '@/api';

// если lodash уже есть (у тебя есть lodash.debounce в PublicationSide)
import _debounce from 'lodash.debounce';

const emit = defineEmits(['rangeValueChanged']);

const props = defineProps({
  label: String,
  property: Number,
  required: Boolean,
});

const fromValue = ref(null); // number|null
const toValue = ref(null); // number|null
const yearOptions = ref([]);

// ✅ один запрос вместо двух подряд (когда выбираешь from потом to)
const debouncedEmit = _debounce(() => {
  emit('rangeValueChanged', {
    property: props.property,
    A: fromValue.value, // number|null
    B: toValue.value, // number|null
  });
}, 250);

async function loadOptions() {
  try {
    const { data } = await api.get(`attributes/select_values/?property=${props.property}`);

    // ✅ поддержка обоих форматов: {results: []} или []
    const list = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];

    yearOptions.value = list
      .map(v => ({
        label: String(v.name), // "2020"
        value: Number(String(v.name)), // 2020
      }))
      .filter(x => Number.isFinite(x.value))
      .sort((a, b) => b.value - a.value);
  } catch (e) {
    console.error('❌ Ошибка загрузки годов:', e);
    yearOptions.value = [];
  }
}

onMounted(loadOptions);
</script>

<style scoped>
@import '@vueform/multiselect/themes/default.css';
</style>
